import { store } from "@store";

export function useNavManager() {
  const navManager = store().navigation;
  return { navManager };
}
